Vue.component("MpModuleTags", {
    props: {
        source: String,
        type: String,
        moduleName: String,
    },
    data: function() {
        return {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            tagList: [],
        };
    },
    computed: {},
    methods: {

        onSourceDataLoad: function(response) {
            if (response.data.result !== this.RESPONSE_OK) {
                return;
            }

            switch (this.type) {
                case 'category':
                    this.tagList = response.data.categories;
                break;

                default:
                    this.tagList = response.data.tags;
                break;
            }
        },

        loadTagList: function() {
            axios
                .get(this.source)
                .then(this.onSourceDataLoad)
                .catch(function(error) {
                    console.log(error);
                });
        },

        init: function() {
            this.loadTagList();
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <section class="tag-ranking">\
        <h1 class="tag-ranking__title">{{this.moduleName}}</h1>\
\
        <ul class="tag-ranking__list">\
            <li class="tag-ranking__item" v-for="tag in tagList">\
                <a class="tag-ranking__link" :class="\'tag-ranking__link--\'+tag.classTag" :href="tag.uri">\
                    <span class="tag-ranking__label">{{tag.tag}}</span>\
                    <span class="tag-ranking__number">{{tag.counter}}</span>\
                </a>\
            </li>\
        </ul>\
    </section>',
});